import router from '@/router';
import Cookies from 'js-cookie';

const getLoggedInUser = async ({ commit, dispatch }) => {
  commit('SET_GET_LOGGED_IN_USER_LOADING', true);
  try {
    const { data } = await window.axios.get('/proxy/get-logged-in-user');

    if (data && data.success === true) {
      const { user } = data;
      commit('SET_USER', { ...user });
      Cookies.set('is_privileged', !!user?.is_privileged);
      if (user.forceResetPassword) {
        router.push({ path: '/settings' });
      }
    } else {
      throw data;
    }
  } catch (error) {
    dispatch('notifications/setError', error.message, { root: true });
  } finally {
    commit('SET_GET_LOGGED_IN_USER_LOADING', false);
  }
};

export default getLoggedInUser;
